import { CategoryApi } from 'api/CategoryApi';
import { backendApiClient } from 'container/backendApiClient';

export const categoryApi = new CategoryApi(backendApiClient);
